import React from "react";
import { browserHistory } from "react-router";
import { formatNumber, getCurrencySymbol } from "../../../../../../lib";
import moment from "moment";

export default function StudentRewardsTableRow({
  onApproveRejectRewardRequest,
  rewardRequest,
  viewOnly,
}) {
  const {
    createdOn,
    creditsToRedeem,
    currencyCode,
    creditValue,
    rewardName,
    status,
    statusDisplay,
    tripProgramScheduleID,
    tripStudentRegistrationID,
  } = rewardRequest;

  // trip applications are not managed via the regular approve/reject flow
  const canManageTripApplication =
    status === "Pending" && tripStudentRegistrationID;
  const canApproveRequest = status === "Pending" && !tripStudentRegistrationID;
  const canRejectRequest =
    (status === "Pending" || status === "Approved") &&
    !tripStudentRegistrationID;

  return (
    <div className="students-rewards-history-table-row">
      <p>{rewardName}</p>
      <div>
        <p className="fw-700">{formatNumber(creditsToRedeem)}</p>
        <p>
          {getCurrencySymbol(currencyCode)}
          {formatNumber(creditValue * creditsToRedeem)}
        </p>
      </div>
      <p>{moment(createdOn).format("MM/DD/YYYY")}</p>
      <p>{statusDisplay}</p>
      <p>
        {!viewOnly && (
          <>
            {canManageTripApplication && (
              <span
                className="link-text"
                onClick={() =>
                  browserHistory.push(
                    `/trips/${tripProgramScheduleID}/students/${tripStudentRegistrationID}`,
                  )
                }
              >
                Manage trip application
              </span>
            )}
            {canApproveRequest && (
              <i
                className="material-icons ml-8 link-text-secondary"
                onClick={() =>
                  onApproveRejectRewardRequest(rewardRequest, true)
                }
                style={{ color: "#76E269" }}
              >
                thumb_up
              </i>
            )}
            {canRejectRequest && (
              <i
                className="material-icons ml-8 link-text-secondary"
                onClick={() =>
                  onApproveRejectRewardRequest(rewardRequest, false)
                }
                style={{ color: "#DC313F" }}
              >
                thumb_down
              </i>
            )}
          </>
        )}
      </p>
    </div>
  );
}
